import { TemplateEditorSagas } from "./TemplateEditor";
import { TemplatesHistorySagas } from "./TemplatesHistory";
import { EditorHomeSagas } from "./EditorHome";
import { TextEditorSagas } from "./TextEditor";
import { DeliveryStatusDashboardSagas } from "./DeliveryStatusDashboard";

export default [
  ...TemplateEditorSagas,
  ...TemplatesHistorySagas,
  ...EditorHomeSagas,
  ...TextEditorSagas,
  ...DeliveryStatusDashboardSagas
];
